import updateSize from '/expert/mobile/updateSize.js';
import updateSlides from '/expert/mobile/updateSlides.js';
import updateAutoHeight from '/expert/mobile/updateAutoHeight.js';
import updateSlidesOffset from '/expert/mobile/updateSlidesOffset.js';
import updateSlidesProgress from '/expert/mobile/updateSlidesProgress.js';
import updateProgress from '/expert/mobile/updateProgress.js';
import updateSlidesClasses from '/expert/mobile/updateSlidesClasses.js';
import updateActiveIndex from '/expert/mobile/updateActiveIndex.js';
import updateClickedSlide from '/expert/mobile/updateClickedSlide.js';

export default {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide,
};
